<template>
    <div class="flex flex-col gap-6">
        <h2 class="text-2xl md:text-4xl font-semibold">Patient Case Review</h2>

        <div>
            <h3 class="text-base md:text-2xl font-semibold mb-3">
                Symptoms of PH1 experienced by patient and journey to diagnosis
            </h3>

            <ul class="list-disc pl-4 font-light">
                <li>
                    A 32-year-old male hypertensive patient was hospitalized on January 29, 2021, in Wuhan, China
                    <ul class="list-inside list-['-_'] pl-6">
                        <li>
                            CT examination revealed bilateral nephrocalcinosis, and the patient had a recent history of
                            elevated SCr, hypertension, and 5 months of maintenance hemodialysis; as a result, the
                            patient was scheduled for a kidney allograft
                        </li>
                    </ul>
                </li>
                <li>
                    After the kidney allograft, development of DGF occurred and acute rejection was suspected based on
                    abnormal SCr and BUN values
                </li>
                <li>This led to a kidney biopsy and subsequent genetic testing, resulting in a PH1 diagnosis</li>
            </ul>
        </div>

        <div>
            <h3 class="text-base md:text-2xl font-semibold mb-3">
                Did misdiagnosis or delayed diagnosis occur from initial presentation?
            </h3>

            <ul class="list-disc pl-4 font-light">
                <li>
                    An opportunity to screen for PH1 before transplantation was missed because no urinary oxalate
                    analysis, molecular genetic testing, and pre-transplant kidney biopsy were performed
                    <ul class="list-inside list-['-_'] pl-6">
                        <li>
                            Kidney biopsy may lead to the identification of CaOx stones which could add to suspicion of
                            PH1
                        </li>
                    </ul>
                </li>
            </ul>
        </div>

        <h3 class="text-base md:text-2xl font-semibold mb-3 p-6 bg-lightblue50 text-center">
            This case highlights the importance of pre-operative PH1 screening, including urine oxalate analysis,
            genetic testing, and renal biopsy in all patients with bilateral nephrocalcinosis or nephrolithiasis
        </h3>
    </div>
</template>
